import { createDownloadableLink } from '@/helpers';
import customToast from '@/new-components/CustomNotification';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  uploadBatchVaccinationRecord:
    (data, callback) =>
    async ({ Api }) => {
      const { result, status } = await Api.post(
        `pax-screenings/import/mass-completed`,
        data,
        '',
        undefined,
        true,
        true
      );
      if (status === 200) {
        customToast('success', 'Upload success');
        callback && callback();

        if (result instanceof Blob && result.size > 0) {
          createDownloadableLink(result, `Batch-Vaccination-Record`);
        }
      }
    },
};

const batchVaccinationRecordUpdateDispatcher = synthesize(
  'batchVaccinationRecordUpdate',
  mapDispatchToAC
);

export default batchVaccinationRecordUpdateDispatcher;
